import type { RouteObject } from "react-router-dom";

export const packageProtectionPlusRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Package Protection Plus" },
    async lazy() {
      const { Page } = await import("../../app/page");
      return { element: <Page /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { PackageProtectionPlus } =
            await import("./package-protection-plus");
          return { Component: PackageProtectionPlus };
        },
      },
    ],
  },
];
